import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatchVmEventList } from '../../global-utils';
import { stylesPropType, vmPropTypes } from '../../global-prop-types';
import vmFunctions from '../../global-utils/vmFunctions';

const VmTextarea = (props) => {
  const {
    vmOnChange,
    vmOnBlur,
    value,
    placeholder,
    variant,
    styles,
    rows,
    isResized,
    isAutoHeight
  } = props;
  const dispatchVmEventList = useDispatchVmEventList();
  const textareaRef = useRef();

  const handleBlur = (ev) => {
    dispatchVmEventList(vmOnBlur, {
      vmFunctions,
      props,
      value: ev.target.value
    });
  };

  const handleResize = (ev) => {
    if (isAutoHeight) {
      const textarea = textareaRef.current;
      textarea.style.height = 'auto';
      const scHeight = ev.target.scrollHeight;
      textarea.style.height = `${scHeight}px`;
    }
  };

  const handleChange = (ev) => {
    const val = ev.target.value;
    // Before setting new value to state, and therefore updateing the textarea
    // we have to adjust the height of the textarea. Otherwise the box flickers on breaking into new line
    handleResize(ev);
    // set value after handleing resize:
    dispatchVmEventList(vmOnChange, {
      vmFunctions,
      props,
      value: val
    });
  };

  return (
    <textarea
      className={variant ?? ''}
      ref={textareaRef}
      onChange={handleChange}
      onBlur={handleBlur}
      // onKeyDown={handleResize}
      // onKeyUp={handleResize}
      value={String(value ?? '')}
      placeholder={placeholder ?? ''}
      style={{ resize: `${isResized ? '' : 'none'}`, ...styles?.wrapper }}
      rows={rows ?? 1}
    />
  );
};

VmTextarea.propTypes = {
  placeholder: PropTypes.string,
  variant: PropTypes.string,
  styles: stylesPropType,
  rows: PropTypes.number,
  isResized: PropTypes.bool,
  isAutoHeight: PropTypes.bool,
  vmOnBlur: PropTypes.array,
  vmOnChange: PropTypes.array,
  value: PropTypes.string
};

VmTextarea.vmPropTypes = {
  placeholder: vmPropTypes.string,
  variant: vmPropTypes.className,
  styles: { wrapper: vmPropTypes.styles },
  rows: vmPropTypes.number,
  isResized: vmPropTypes.boolean,
  isAutoHeight: vmPropTypes.boolean,
  vmOnBlur: PropTypes.array,
  vmOnChange: PropTypes.array,
  value: vmPropTypes.string
};

export default VmTextarea;
